import { useMemo, useState } from "react";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import api from "../api/axios";

const API_URL = process.env.REACT_APP_API_URL;

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const token = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("token");
  }, []);

  const handleSubmit = async () => {
    setSuccessMessage("");
    setErrorMessage("");

    if (!token) {
      setErrorMessage("Şifre sıfırlama bağlantısı geçersiz.");
      return;
    }

    if (!newPassword || !confirmPassword) {
      setErrorMessage("Lütfen tüm alanları doldurun.");
      return;
    }

    if (newPassword.length < 6) {
      setErrorMessage("Şifre en az 6 karakter olmalıdır.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage("Şifreler eşleşmiyor.");
      return;
    }

    try {
      setLoading(true);

      const response = await api.post(`/auth/reset-password`, {
        token,
        newPassword,
        confirmPassword,
      });

      if (response.data?.success) {
        setSuccessMessage("Şifreniz başarıyla güncellendi. Giriş ekranına dönebilirsiniz.");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setErrorMessage(response.data?.message || "Şifre güncellenemedi.");
      }
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message ||
          "Bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-800 flex items-center justify-center px-2 bg-#0f172a">
      <div className="w-full max-w-lg bg-white rounded-3xl shadow-xl overflow-hidden">
        <div className="bg-slate-900 px-4 py-4 text-center">
          <div className="text-3xl font-black p-4 text-white tracking-tight">
            KasamBenim
          </div>

          <div className="w-10 h-1 mt-3 mx-auto rounded-full bg-gradient-to-r from-blue-600 to-emerald-500" />

          <h1 className="mt-4 text-2xl font-bold text-white">
            Şifrenizi yenileyin
          </h1>

          <p className="mt-3 text-sm leading-6 text-slate-300">
            Yeni şifrenizi belirleyerek hesabınıza tekrar giriş yapabilirsiniz.
          </p>
        </div>

        <div className="px-8 py-8">
          {!token && (
            <Message
              severity="error"
              text="Şifre sıfırlama bağlantısı geçersiz."
              className="w-full mb-4"
            />
          )}

          {successMessage && (
            <Message
              severity="success"
              text={successMessage}
              className="w-full mb-4"
            />
          )}

          {errorMessage && (
            <Message
              severity="error"
              text={errorMessage}
              className="w-full mb-4"
            />
          )}

          <div className="mb-5">
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Yeni Şifre
            </label>
            <Password
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              feedback={false}
              toggleMask
              disabled={!token || loading || !!successMessage}
              inputClassName="w-full"
              className="w-full"
              placeholder="Yeni şifrenizi girin"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Yeni Şifre Tekrar
            </label>
            <Password
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              feedback={false}
              toggleMask
              disabled={!token || loading || !!successMessage}
              inputClassName="w-full"
              className="w-full"
              placeholder="Yeni şifrenizi tekrar girin"
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            />
          </div>

          <Button
            label={loading ? "Güncelleniyor..." : "Şifremi Güncelle"}
            icon="pi pi-lock"
            loading={loading}
            disabled={!token || loading || !!successMessage}
            onClick={handleSubmit}
            className="w-full"
            style={{
              background: "#10b981",
              borderColor: "#10b981",
              borderRadius: "999px",
              fontWeight: 800,
              padding: "0.85rem 1rem",
            }}
          />

          <button
            type="button"
            onClick={() => (window.location.href = "/login")}
            className="w-full mt-5 inline-flex items-center text-white justify-center gap-2 rounded-full border border-sky-400 bg-sky-700 px-4 py-3 text-sm font-bold  transition-all duration-200 hover:bg-sky-500 hover:text-emerald-800"
            >
            <i className="pi pi-arrow-left text-xs" />
            Giriş ekranına dön
            </button>
        </div>
      </div>
    </div>
  );
}